import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import { mainURL } from "../../assets/constants/api";
import { useAuth } from "../../hooks/useAuth";

import ButtonLoader from "../../components/items/buttonLoader";
import AlertMessage from "../../components/layout/alertMessage";
import MemberCard from "../../components/items/memberCard";
const Members = () => {
  const { token } = useAuth();
  const [members, setMembers] = useState({
    members: [],

    loading: true,
    error: null,
  });

  const fetchMembers = async (page = 1) => {
    try {
      setMembers((prev) => ({ ...prev, loading: true }));
      const response = await axios.get(
        `${mainURL}/web/members/get-members?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "application/json",
            // Accept: "application/json",
          },
        }
      );

      setMembers({
        members: response.data.data.members,
        meta: response.data.data.meta,
        loading: false,
        error: null,
      });
    } catch (error) {
      setMembers({
        members: [],
        meta: null,
        loading: false,
        error: error.message,
      });
    }
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  if (members.loading)
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "50vh" }}
      >
        <ButtonLoader />
      </div>
    );
  if (members.error)
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "50vh" }}
      >
        <AlertMessage message="حدث خطأ ما لا يمكن تحميل الأعضاء" />
      </div>
    );

  return (
    <section className="blog-section padding-tb">
      <div className="container">
        <div className="section-header">
          <h4 className="theme-color">اعثر على شريكك اليوم !</h4>
          <h2>اكتشف الاعضاء الجدد</h2>
        </div>
        <div className="main-blog">
          <div className="row">
            <div className="col-lg-12 col-12">
              <div className="row justify-content-center">
                {members.members.map((member, index) => (
                  <MemberCard member={member} key={index} />
                ))}
                <div className="member-button-group d-flex flex-wrap justify-content-center">
                  <Link to="/members" className="lab-btn">
                    <i className="icofont-users"></i>
                    <span>مشاهدة بقية الأعضاء</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Members;
